import { Label } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './GalleryLabels.css';
import { EGalleryLabelColor, IGalleryLabel } from '../../types/gallery-label';
import { GalleryLabelsIcon } from '../GalleryLabelsIcon';

interface IGalleryLabelsProps {
  labels: IGalleryLabel[];
  hasFeatures: boolean;
}

const BACKGROUND: Record<EGalleryLabelColor, string> = {
  [EGalleryLabelColor.Black]: 'var(--theme-dark)',
  [EGalleryLabelColor.Grey]: 'var(--gray60_100)',
  [EGalleryLabelColor.LightGrey]: 'var(--surface-neutral-default)',
  [EGalleryLabelColor.Orange]: 'var(--accent-warning-primary)',
  [EGalleryLabelColor.Green]: 'var(--accent-positive-primary)',
  [EGalleryLabelColor.Blue]: 'var(--accent-main-primary)',
  [EGalleryLabelColor.Red]: 'var(--accent-negative-primary)',
};

export const GalleryLabels = ({ labels, hasFeatures }: IGalleryLabelsProps) => {
  return (
    <div className={classNames(styles['container'], hasFeatures && styles['has-features'])}>
      {labels.map(({ label, color, customColor, iconUrl, uiKitIcon, onClick }) => (
        <div className={classNames(styles['label'], !customColor && styles[`${color}-label`])} key={label}>
          <Label
            background={BACKGROUND[color]}
            color="current_color"
            icon={iconUrl ? <GalleryLabelsIcon iconUrl={iconUrl} /> : undefined}
            rightIcon={uiKitIcon}
            onClick={onClick}
          >
            {label}
          </Label>
        </div>
      ))}
    </div>
  );
};
